export default {
    data() {
        return {
            projectNames: ['Benocs Analytics', 'VueWorld', 'BattleHeaven Fighting: RPG', 'Aer Ticket Billing Tool', 'CloudRoad', 'Danlos Cities'],
        }
    }
};